import maqLogo from '../images/maq-logo.svg';
import acmLogo from '../images/acm-logo.svg';
import rentWheelsImg from '../images/rentwheels.jpg';

export const Bio = {
    name: "Bhavy Zala",
    roles: [
      "Programmer",
      "MERN Developer",
      "Frontend Developer",
      "Backend Developer"
    ],
    description:
      "I am a Software Engineer with a B.Tech in Computer Science and Engineering from Nirma University (2026). I am always eager to learn, grow, and take on new challenges to deliver meaningful and impactful solutions.\n\nI specialize in full-stack web development with expertise in modern technologies and frameworks. I enjoy building clean, efficient, and user-friendly applications.",
    github: "https://github.com/zalabhavy",
    resume:
      "https://drive.google.com/file/d/1o3DlDFDjAFDnrN6kVa7ghYhctZ4-JCTp/view?usp=sharing",
    linkedin: "https://www.linkedin.com/in/bhavy-zala-59bb76241?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    insta: "https://www.instagram.com/bhavy_zala499/",
    email: "zalabhavy2004@gmail.com"
  };
  
  export const skills = [
    {
      title: "Frontend",
      skills: [
        {
          name: "HTML",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
        },
        {
          name: "CSS",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
        },
        {
          name: "JavaScript",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
        },
        {
          name: "Bootstrap",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg",
        },
        {
          name: "React Js",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
        },
        {
          name: "Tailwind CSS",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tailwindcss/tailwindcss-original.svg",
        },
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: "Node Js",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
        },
        {
          name: "Express Js",
          image: "https://skillicons.dev/icons?i=express",
        },
        {
          name: "MySQL",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
        },
        {
          name: "MongoDB",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
        },
        {
          name: "Spring Boot",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg",
        },
      ],
    },
    {
      title: "Tools",
      skills: [
        {
          name: "Git",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
        },
        {
          name: "GitHub",
          image: "https://skillicons.dev/icons?i=github",
        },
        {
          name: "Google Cloud",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/googlecloud/googlecloud-original.svg",
        },
        {
          name: "AWS",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/amazonwebservices/amazonwebservices-original-wordmark.svg",
        },
        {
          name: "VS Code",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg",
        },
        {
          name: "Postman",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postman/postman-original.svg",
        },
        {
          name: "Figma",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg",
        },
        {
          name: "Azure",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg",
        },
      ],
    },
    {
      title: "Coding Language",
      skills: [
        {
          name: "C++",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg",
        },
        {
          name: "C",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-original.svg",
        },
        {
          name: "Java",
          image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
        },
        {
          name: "SQL",
          image: "https://skillicons.dev/icons?i=mysql",
        },
      ],
    },
  ];
  
  export const experiences = [
    {
      id: 0,
      img: maqLogo,
      role: "Associate Software Engineer",
      company: "MAQ Software",
      date: "Jan 2026 - Present",
      desc: "• Built a Cross-Product Testing MCP Agent using Playwright and Azure DevOps for automated test generation, review, and debugging.\n• Optimized scalable ETL pipelines and CI/CD workflows using Azure Data Factory, Microsoft Fabric, and GitHub Actions.",
    },
    {
      id: 1,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQiXrJaCJs5r4spa8O6wMPycw-NR1a6_fLflw&s",
      role: "MERN Stack Intern",
      company: "Techmicra IT Solutions",
      date: "May 2025 - July 2025",
      desc: "During this internship, I worked with live APIs, understood the MERN stack by working on multiple projects, and learned about MERN development and cloud deployment.",
    },
    {
      id: 2,
      img: "https://media.licdn.com/dms/image/v2/D4D0BAQHpHRHK9Bp43w/company-logo_200_200/company-logo_200_200/0/1694157009348/developer_students_club_nirma_university_logo?e=2147483647&v=beta&t=8gopbMo0gINe8FQ8KccTfLMzfbfEeK0TOXACouKDgqA",
      role: "Web Lead",
      company: "Google Developer Groups",
      date: "Oct 2024 - Present",
      desc: "Led Web Development for Google Developer Club, created a Leaderboard website for GenAI, and organized sessions on Web Development.",
    },
    {
      id: 3,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTlfuQN1b_7UYg_8rRoTao5NHJ7KPHLPHJefw&s",
      role: "Intern",
      company: "RapidBox",
      date: "Jun 2024 - Jul 2024",
      desc: "Worked on the Spring Boot Project",
      skills: [
       "Spring Boot",
       "MySql",
       "Java",
       "Postman",
       "API Services"
      ],
    },
    {
        id: 4,
        img: "https://user-images.githubusercontent.com/63473496/153487849-4f094c16-d21c-463e-9971-98a8af7ba372.png",
        role: "Open Source Contributor",
        company: "GirlScript Summer of Code",
        date: "May 2024 - Aug 2024",
        desc: "Under Top 10 Contrubutors",
    },
    {
        id: 5,
        img: "https://repository-images.githubusercontent.com/389729275/371ba38b-8a03-4bff-916c-c3fa5396ceda",
        role: "Campus Mantri",
        company: "GeeksforGeeks",
        date: "Apr 2024 - Present",
        desc: "Introduced GeeksforGeeks to campus, encouraging students to actively engage by solving their daily Problem of the Day challenges.",
    },
    {
        id: 6,
        img: acmLogo,
        role: "Vice-President",
        company: "ACM - Nirma University",
        date: "Sep 2023 - July 2024",
        desc: "Our club organized an amazing event with over 100 students participating. The energy, creativity, and collaboration made it an unforgettable experience for everyone!",
    },
  ];
  
  export const education = [
    {
      id: 0,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRRu6CPuqb7dANC_NWGUv4EDzO91Frw9MDJLw&s",
      school: "Nirma University, Ahmedabad",
      date: "Jul 2022 - Apr 2026",
      grade: "8.72 CGPA",
      desc: "Completed Bachelor's degree in Computer Science and Engineering from Nirma Institute of Technology, Ahmedabad.",
      degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
    },
    {
      id: 1,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQrXvNMPFPr24jnn-MLdJViugjgWuelke0j6A&s",
      school: "Sahjanand School of Achiever, Gandhinagar",
      date: "May 2020 - Apr 2022",
      grade: "92%",
      desc: "I completed my class 12 high school education at Sahjanand School of Achiever, Gandhinagar.",
      degree: "HSC (Gujarat Secondary and Higher Secondary Education Board)",
    },
    {
      id: 2,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT18-8AQxbsKXYuX7D-5w_2FGHYIErHdLVigw&s",
      school: "Sharda Mandir, Kapadwanj",
      date: "Apr-2020",
      grade: "89.5%",
      desc: "I completed my class 10 education at Sharda Mandir, Kapadwanj.",
      degree: "SSC (Gujarat Secondary and Higher Secondary Education Board)",
    },
  ];
  
  export const projects = [
    {
      id: 1,
      title: "RentWheels",
      category: "web app",
      description:
        "Built a full-stack vehicle rental platform with complete CRUD operations for branches, vehicles, and bookings, featuring an admin dashboard with revenue analytics and order management. Implemented booking lifecycle management with real-time vehicle availability tracking, cascading deletes, time-slot conflict prevention, and role-based customer/admin views. Developed RESTful APIs with global exception handling, integrated with a responsive frontend featuring search/filter, input validation, and multi-customer session management using Context API.",
      image: rentWheelsImg,
      tags: ["Spring Boot", "MySQL", "Docker", "React.js", "Tailwind CSS", "Postman"],
      github: "https://github.com/zalabhavy/Rental_Services",
      live: "https://rental-services-bhavy.vercel.app/",
    },
    {
      id: 2,
      title: "HostelHub",
      category: "web app",
      description:
        "Developed a role-based platform supporting Student, Admin, and Alumni roles with 12+ modules, Google OAuth, admin approval workflows, real-time sync, and push notifications. Engineered an alumni mentorship subscription system with payment verification, automated session expiry, private messaging, and atomic operations for data consistency. Designed complaint tracking, transport booking, meal attendance, food menu, security deposit, lost-and-found, document verification, rewards, community chat, notices, and analytics dashboards.",
      image:
        "https://images.unsplash.com/photo-1520277739336-7bf67edfa768?w=800&q=80&auto=format&fit=crop",
      tags: ["React.js", "Firebase", "Tailwind CSS", "Postman"],
      github: "https://github.com/zalabhavy/Hostel_Management_Project",
      live: "https://hostel-a1a92.web.app/home",
    },
  ];
  export const TimeLineData = [
    { year: 2022, text: "Problem Solving" },
    { year: 2023, text: "DSA and Web Development" },
    { year: 2024, text: "Open Source and DBMS" },
  ];